'use strict';

var mobileAuthWin;
var mobileAuthWinAutoClosed = false;
var clearUARProduct = true;
var mobileAuthInitiator = '';
var clientSideValidation = require('org/components/common/clientSideValidation');
var disableCloseEvent = false;

/**
 * Removes login, registration and mobile auth modals
 */
function removeModals() {
    if ($('#mobileAuthModal').length !== 0) {
        $('#mobileAuthModal').remove();
    }
    if ($('#loginModal').length > 0) {
        $('#loginModal').remove();
    }
    if ($('#newUserRegisterModal').length > 0) {
        $('#newUserRegisterModal').remove();
    }
    if ($('#uarModal').length > 0) {
        $('#uarModal').remove();
    }
    $('html').removeClass('modal-open');
}

/**
 * Open create account modal
 * @param {Object} $this current element
 */
function getModalHtmlElement() {
    removeModals();
    var htmlString = '<!-- Modal -->'
        + '<div class="modal g-modal g-modal-mobileAuth" id="mobileAuthModal" role="dialog">'
        + '<div class="modal-dialog g-modal-dialog ">'
        + '<!-- Modal content-->'
        + '<div class="modal-content g-modal-content">'
        + '<div class="modal-body g-modal-body"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
}

/**
 * Closes the popup and the spinner on the window opener
 */
function closeMobileAuthPopup() {
    if (mobileAuthWin && !mobileAuthWin.closed) {
        mobileAuthWinAutoClosed = true;
        mobileAuthWin.close();
        $.spinner().stop();
    }
}

/**
 * Initiate Mobile Authentication
 */
function initiateMobileAuth() {
    // eslint-disable-next-line consistent-return
    $('body').on('click', '.js-init-mobileauth, .js-init-mobileauth-login, .js-account-mobile-update, .js-init-mobileauth-duplicate', function (e) {
        e.preventDefault();
        if ($('.register-in-page').length > 0 && $(e.target).hasClass('js-init-mobileauth')) {
            if ($(e.target).closest('#loginModal').length > 0) {
                $('#loginModal').modal('hide');
            }
            return false;
        }
        if ($('.b-order-confirmation').length > 0) {
            if ($(e.target).hasClass('js-init-mobileauth-login')) {
                mobileAuthInitiator = 'login';
            } else {
                mobileAuthInitiator = 'register';
            }
        }
        var url = $(this).data('href');
        getModalHtmlElement();
        $.spinner().start();
        $('body').find('.b-loader').css('z-index', '999');
        $('.b-loader-after').css('z-index', '998');
        var currentPage = !$('.b-order-confirmation').length ? window.location.href : null;
        if ($('.l-pdp').length && window.uarProductID && !(new URLSearchParams(window.location.href).has('uarProductID'))) {
            var uarQty = $('.js-quantity-select').val();
            var currentPageURL;
            if (currentPage.indexOf('#' !== -1)) {
                var noHashURL = currentPage.split('#')[0];
                var hash = currentPage.split('#')[1];
                currentPageURL = new URL(noHashURL);
                currentPageURL.searchParams.set('uarProductID', window.uarProductID);
                currentPageURL.searchParams.set('uarQty', uarQty);
                currentPageURL.searchParams.set('triggerATC', true);
                currentPage = currentPageURL.href + '#' + hash;
            } else {
                currentPageURL = new URL(currentPage);
                currentPageURL.searchParams.set('uarProductID', window.uarProductID);
                currentPageURL.searchParams.set('uarQty', uarQty);
                currentPageURL.searchParams.set('triggerATC', true);
                currentPage = currentPageURL.href;
            }
            window.history.replaceState(null, null, currentPage); // or pushState
        }

        $.ajax({
            url: url,
            data: { format: 'ajax', currentPage: currentPage },
            error: function (err) {
                $.spinner().stop();
                console.log(err);
            },
            success: function (data) {
                $.spinner().stop();
                $('body').find('.modal-backdrop.show').remove();
                $('.modal-body').empty();
                $('.modal-body').html(data);
                if ($('.disableOuterClick').length) {
                    $('#mobileAuthModal').attr('data-backdrop', 'static');
                }
                $('#mobileAuthModal').modal('show');
                $('#mobileAuthModal').next('.modal-backdrop.show').css('z-index', '999');
            }
        });
    });
}

/**
 * Open Mobile Authentication Popup
 */
function openMobileAuthModal() {
    // eslint-disable-next-line consistent-return
    $('body').on('click', '.js-trigger-mobile-auth', function (e) {
        e.preventDefault();
        if (e.ctrlKey || e.metaKey) {
            return false;
        }
        if ($('.b-order-confirmation-mobileauth_card').length && $(e.target).closest('.b-order-confirmation').length) {
            $('.b-order-confirmation-mobileauth_card').attr('data-clicked', 'true');
        }

        var url = $(this).data('href') || $(this).attr('href');
        var consentForm = $(this).closest('form.js-consent-form');
        if (consentForm.length) {
            clientSideValidation.checkMandatoryField(consentForm);
            if (consentForm.find('input.is-invalid').length) {
                return false;
            }

            url = url + '?' + consentForm.serialize();
        }

        clearUARProduct = false;
        disableCloseEvent = true;
        $('#mobileAuthModal').modal('hide');
        disableCloseEvent = false;
        $.spinner().start();
        $('body').find('.b-loader').css('z-index', '999');
        var centeredPopUp = require('../utils/centeredPopUp');
        mobileAuthWin = centeredPopUp.openPopUp(url, '', 550, 680);
        $(window).on('beforeunload', function () {
            // Close the popup window when the main window is closed
            closeMobileAuthPopup();
            if (mobileAuthWinAutoClosed) {
                $.spinner().stop();
            }
        });

        var checkPopup = setInterval(function () {
            if (mobileAuthWin && mobileAuthWin.closed) {
                if (!mobileAuthWinAutoClosed) {
                    if ($('.b-order-confirmation').length > 0) {
                        if ($('.b-order-confirmation-mobileauth_card').attr('data-clicked') === 'true') {
                            $('.b-order-confirmation-mobileauth_card').attr('data-clicked', 'false');
                            $.spinner().stop();
                        } else if (mobileAuthInitiator === 'login' && $('.b-order-confirmation-mobileauth-url').attr('data-homepage-url')) {
                            window.location.href = $('.b-order-confirmation-mobileauth-url').attr('data-homepage-url');
                        } else if (mobileAuthInitiator === 'register' && $('.b-order-confirmation-mobileauth-url').attr('data-homepage-url-mobileauth')) {
                            window.location.href = $('.b-order-confirmation-mobileauth-url').attr('data-homepage-url-mobileauth');
                        }
                    } else {
                        window.location.reload();
                    }
                } else {
                    $.spinner().stop();
                }
                mobileAuthInitiator = '';
                clearInterval(checkPopup);
            }
        }, 1000);
    }).on('contextmenu', '.js-trigger-mobile-auth', function (e) {
        e.preventDefault();
    // eslint-disable-next-line consistent-return
    }).on('click', '.init-mobileauth-ordertrack', function () {
        window.location.href = $('.mobile-auth-order-track').attr('data-href');
    });
}

/**
 * Overwrites the values on the registration form with data from NiceID and disables the fields
 * @param {Object} decryptedRetData decrypted Data returned from NiceID
 */
function updateValuesOnConfirmationPage(decryptedRetData) {
    if ($('.phoneMobileAuth').length > 0) {
        var unsplitPhone = decryptedRetData.mobileno;
        $('.b-order-confirmation_card .phoneMobileAuth').val(unsplitPhone);
        $('.b-order-confirmation_card .phoneMobileAuth').attr('disabled', true);
    } else {
        var splitPhone = decryptedRetData.splitPhone.split('-');
        if ($('.phoneMobile1').length > 0) {
            $('.b-order-confirmation_card .phoneMobile1').val(splitPhone[0]);
            $('.b-order-confirmation_card .phoneMobile1').attr('disabled', true);
        }

        if ($('.phoneMobile2').length > 0) {
            $('.b-order-confirmation_card .phoneMobile2').val(splitPhone[1]);
            $('.b-order-confirmation_card .phoneMobile2').attr('readonly', true);
        }

        if ($('.phoneMobile3').length > 0) {
            $('.b-order-confirmation_card .phoneMobile3').val(splitPhone[2]);
            $('.b-order-confirmation_card .phoneMobile3').attr('readonly', true);
        }
    }
    $('.b-order-confirmation_card #birthYear').val(decryptedRetData.birthYear);
    $('.b-order-confirmation_card #birthYear').attr('disabled', true);
    $('.b-order-confirmation_card #birthMonth').val(parseInt(decryptedRetData.birthMonth, 10));
    $('.b-order-confirmation_card #birthMonth').attr('disabled', true);
    $('.b-order-confirmation_card #birthDay').val(parseInt(decryptedRetData.birthDay, 10));
    $('.b-order-confirmation_card #birthDay').attr('disabled', true);
    if (decryptedRetData.gender === '0') {
        $('.b-order-confirmation_card #gender').val('2'); // Setting female gender
    } else {
        $('.b-order-confirmation_card #gender').val(decryptedRetData.gender);
    }
    $('.b-order-confirmation_card #gender').attr('disabled', true);
}

/**
 * Handle message from popup
 */
function handleMessageFromPopup() {
    window.addEventListener('message', function (event) {
        if (event.origin !== window.location.origin) {
            return;
        }
        if (event.data) {
            var messageData = event.data;
            if (messageData.logoutUrl) {
                closeMobileAuthPopup(mobileAuthWin);
                window.location.href = messageData.logoutUrl;
            } else if (messageData.reloadPage) {
                closeMobileAuthPopup(mobileAuthWin);
                window.location.reload();
            } else if (messageData.triggerRegistration) {
                closeMobileAuthPopup(mobileAuthWin);
                removeModals();
                if (messageData.decryptedRetData && $('.b-order-confirmation').length > 0 && $('.b-order-confirmation-mobileauth_card').attr('data-clicked') === 'true') {
                    $('.b-order-confirmation-mobileauth_card').attr('data-clicked', 'false');
                    updateValuesOnConfirmationPage(messageData.decryptedRetData);
                    $('.b-order-confirmation-mobileauth_card').addClass('d-none');
                    $('.b-order-confirmation_account .b-order-confirmation_card').removeClass('d-none');
                } else if ($('#checkout-main').length > 0) {
                    $('.buttons-container').find('.js-register').eq(0).trigger('click');
                } else {
                    $('.b-header_account-link.js-register').eq(0).trigger('click');
                }
            } else if (messageData.containerHTML) {
                closeMobileAuthPopup(mobileAuthWin);
                $('body').find('.modal-backdrop.show').remove();
                if ($('.modal-body').length && $('.modal-body').find('.initiate-mobile-auth').length) {
                    $('.modal-body').find('.initiate-mobile-auth').empty();
                    $('.modal-body').find('.initiate-mobile-auth').html(messageData.containerHTML);
                } else {
                    getModalHtmlElement();
                    $('.modal-body').empty();
                    $('.modal-body').html(messageData.containerHTML);
                }
                if (messageData.disableOuterClose) {
                    $('#mobileAuthModal').attr('data-backdrop', 'static');
                }
                $('#mobileAuthModal').modal('show');
                $('#mobileAuthModal').next('.modal-backdrop.show').css('z-index', '999');
            }
        }
    });
}

/**
 * Handles buttons for mobile authentication completion popup
 */
function handleCompleteAuthPopup() {
    $('body').on('click', '.js-complete-mobileauth, .js-cancel-mobileauth', function (e) {
        e.preventDefault();
        var requestData = {
            format: 'ajax'
        };
        if ($(e.target).hasClass('js-complete-mobileauth')) {
            var $requiredCheckbox = $('#mobile-auth-update-checkbox');
            if ($requiredCheckbox.length && !$requiredCheckbox.is(':checked')) {
                $requiredCheckbox.closest('.form-group').find('.invalid-feedback').html($requiredCheckbox.data('missing-error'));
                return;
            }
            if ($('#add-to-addsmsto-list').length) {
                requestData.smsOptIn = $('#add-to-addsmsto-list').is(':checked');
            }
        }
        $('.js-complete-mobileauth').spinner().start();
        $('body').find('.b-loader').css('z-index', '999');
        $('.js-complete-mobileauth').css('background-color', '#b4b4b4').css('border-color', '#b4b4b4');
        $.ajax({
            url: $(this).data('href'),
            type: 'POST',
            data: requestData,
            error: function (err) {
                console.log(err);
            },
            success: function (data) {
                if (data.success) {
                    if (data.redirectUrl) {
                        window.location.href = data.redirectUrl;
                    } else {
                        window.location.reload();
                    }
                }
            }
        });
    });
}

/**
 * Open mobile auth popup on page load
 */
function initiateMobileAuthOnPageLoad() {
    var homepagePendingMobileAuth = $('input[name="initiateMobileAuth"]').val() === 'true' && $('.js-login').length === 0 && $('.js-header-mobileauth-pending').length > 0;
    if (homepagePendingMobileAuth || ($('.l-pdp').length && $('.pdp-mobile-auth').length && $('.pdp-mobile-auth').attr('data-mobileauth-enabled') === 'true' && $('.pdp-mobile-auth').attr('data-mobileauth-pending') === 'true')) {
        $('.js-init-mobileauth-login').eq(0).trigger('click');
        return;
    }

    var homepagePendingMobileAuthDuplicate = $('input[name="initiateMobileAuth"]').val() === 'duplicate' && $('.js-init-mobileauth-duplicate').length;
    if (homepagePendingMobileAuthDuplicate) {
        $('.js-init-mobileauth-duplicate').eq(0).trigger('click');
    }
}

/**
 * Removes early access window variables and search parameters when mobile auth modal is closed
 */
function clearEarlyAccessSelections() {
    $('body').on('hidden.bs.modal', '#mobileAuthModal', function () {
        if ($('#mobileAuthModal').find('.mobile-auth-duplicate').length !== 0) {
            if (window.keepPage) {
                delete window.keepPage;
            } else {
                window.location.reload();
            }
        }
        if ($('.l-pdp').length > 0 && (!mobileAuthWin || mobileAuthWin.closed) && clearUARProduct === true) {
            var urlParams = new URLSearchParams(window.location.search);
            if (urlParams.has('triggerATC') || urlParams.has('uarProductID')) {
                urlParams.delete('uarProductID');
                urlParams.delete('triggerATC');
                urlParams.delete('uarQty');
                delete window.uarProductID;
                var url = window.location.pathname + '?' + urlParams.toString();
                // eslint-disable-next-line no-restricted-globals
                history.replaceState({}, '', url);
            }
        }
        clearUARProduct = true;
    });
}

/**
 * Function to handle page reload on duplicate popup close
 */
function handleDuplicationModalButtons() {
    $('body').on('click', '.js-duplication-login', function (e) {
        e.preventDefault();
        window.keepPage = true;
        $('#mobileAuthModal').modal('hide');
        $('.mobile-auth-duplicate-buttons .js-login').trigger('click');
    });
}

/**
 * Function to handle close event of mobile auth popup
 */
function handleClosePopup() {
    $('body').on('hidden.bs.modal', '#mobileAuthModal', function () {
        // To fix "Blocked aria-hidden on an element because its descendant retained focus..." error on chrome
        if (document.activeElement) {
            document.activeElement.blur();
        }
        var initiateMobileAuthElm = $('#mobileAuthModal').find('.initiate-mobile-auth');
        if (!disableCloseEvent && initiateMobileAuthElm.length) {
            var isLoggedIn = initiateMobileAuthElm.data('customer-logged-in') === true;
            var logoutUrl = initiateMobileAuthElm.data('logout-url');
            if (isLoggedIn && logoutUrl) {
                window.location.href = logoutUrl;
            }
        }
    });
}

module.exports = {
    initiateMobileAuth: initiateMobileAuth,
    openMobileAuthModal: openMobileAuthModal,
    handleMessageFromPopup: handleMessageFromPopup,
    handleCompleteAuthPopup: handleCompleteAuthPopup,
    initiateMobileAuthOnPageLoad: initiateMobileAuthOnPageLoad,
    clearEarlyAccessSelections: clearEarlyAccessSelections,
    handleDuplicationModalButtons: handleDuplicationModalButtons,
    handleClosePopup: handleClosePopup
};
